import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import routing from "routing";
import { type DeckStats, DeckType } from "src/api/flashcardDecks";
import { OutlinedTextBlackButton } from "src/components/Default/LekUI/Button";
import { DefaultDeckStatisticsModal } from "src/components/Modals/StatisticsModals/DefaultDeckStatisticsModal";
import { buildDeckStatsContent } from "src/components/Modals/StatisticsModals/deckStatsContent";
import { KeepLearningButton } from "src/components/Modals/StatisticsModals/KeepLearningButton";

interface SpacedRepetitionDeckStatisticsModalProps {
	onClose: () => void;
	isLoading?: boolean;
	stats: DeckStats;
	startDate?: string;
	endDate?: string;
	hidePrimaryAction?: boolean;
	datePicker?: ReactNode;
}

export const SpacedRepetitionDeckStatisticsModal = ({
	onClose,
	isLoading,
	stats,
	startDate,
	endDate,
	hidePrimaryAction,
	datePicker,
}: SpacedRepetitionDeckStatisticsModalProps) => {
	const { t } = useTranslation();
	const { chart, statsList } = buildDeckStatsContent(
		DeckType.SpacedRepetition,
		stats,
		t,
	);

	const primaryAction = (
		<>
			<KeepLearningButton deckId={stats.deckId} />
			<OutlinedTextBlackButton
				component={Link}
				to={routing.paths.userDecks}
				className="btn-size-big w-100"
				data-test-id="deck-statistics-show-other-decks"
			>
				{t("modals.deckStatistics.showOtherDecks", "Zobacz inne")}
			</OutlinedTextBlackButton>
		</>
	);

	return (
		<DefaultDeckStatisticsModal
			onClose={onClose}
			isLoading={isLoading}
			chart={chart}
			statsList={statsList}
			primaryAction={primaryAction}
			deckId={stats.deckId}
			deckType={DeckType.SpacedRepetition}
			startDate={startDate}
			endDate={endDate}
			hidePrimaryAction={hidePrimaryAction}
			datePicker={datePicker}
		/>
	);
};
